import { Panel, Row } from "@/components";
import { NO_VALUE } from "@/constants";
import { selectRequestFormStore, useBoundStore } from "@/services/stores";
import { map } from "lodash";

export const UserSummaryReview = () => {
  const { requestFormData } = useBoundStore(selectRequestFormStore);

  return (
    <Panel header="Users">
      <Row>
        {requestFormData?.Personnels
          ? map(requestFormData?.Personnels, (user, key) => {
              return (
                <span key={`user-${key}`}>
                  {user?.WorkerFirstName
                    ? user?.WorkerFirstName
                    : user?.WorkerFirstName ?? NO_VALUE}
                  ,{" "}
                </span>
              );
            })
          : NO_VALUE}
      </Row>
    </Panel>
  );
};
